export class OffboardingCheckListResultClass {
  ResultID: number;
  Empcode: number;
  ReviewerCode: number;
  FeedbackID: number;
  FeedbackDescription: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  Comments: string;
  radioNameYes: string;
  radioNameNo: string;
  radioNameNA: string;
  HRAmount: number;
  HRAnswerComments: string;
  RadioAnswer: number;
  showAmountBox: boolean;
  showFinanceAmountBox: boolean;
  requiredAstric: boolean = false;
  ForwardedMailNoOfDays: number;
  requiredAstricForAdmin: boolean = false;
}
